import { render, staticRenderFns } from "./aiBooking.vue?vue&type=template&id=f6191eae&"
import script from "./aiBooking.vue?vue&type=script&lang=js&"
export * from "./aiBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6191eae')) {
      api.createRecord('f6191eae', component.options)
    } else {
      api.reload('f6191eae', component.options)
    }
    module.hot.accept("./aiBooking.vue?vue&type=template&id=f6191eae&", function () {
      api.rerender('f6191eae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/aiBooking.vue"
export default component.exports